import React, { useState, useEffect, useRef } from 'react';
import './index.scss';
import back from '../../../asset/img/back.png';
import { message } from 'antd';
import coinMarket from '../../../asset/img/coinMarket.png';
import { useNavigate } from 'react-router-dom';
// import food1 from '../../../asset/img/food1.png';
// import food2 from '../../../asset/img/food2.png';
// import food3 from '../../../asset/img/food3.png';
// import food4 from '../../../asset/img/food4.png';
import food1 from '../../../asset/img/pet-food1.png';
import food2 from '../../../asset/img/pet-food2.png';
import food3 from '../../../asset/img/pet-food3.png';
import food4 from '../../../asset/img/pet-food4.png';
import gift from '../../../asset/img/pet-gift.png';
import gold from '../../../asset/img/pet-gold.png';
import { getStoreGoodList, StoreExchange, getUserInfo } from 'network';
import { useDispatch } from 'react-redux';
import { setUser } from 'actions';

const FoodList = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [coin, setCoin] = useState(0);
    const [foodList, setFoodList] = useState([{
        name: '香蕉',
        coin: '金币：',
        valuename: '能量：',
        img: food1,
        scribe: ['便宜', '猴类都爱吃'],
        price: '10',
        value: '10',
        goods_id: "72db4051-7fc7-44ad-a4df-e16a3c21d478"
    }, {
        name: '蟠桃',
        coin: '金币：',
        valuename: '能量：',
        img: food2,
        scribe: ['仙界', '口味独特',],
        price: '15',
        value: '20',
        goods_id: "3cc68a42-529c-4b2a-8d0b-1db08b55e6cf"
    }, {
        name: '人参果',
        coin: '金币：',
        valuename: '能量：',
        img: food3,
        scribe: ['万年结果', '价格美丽'],
        price: '20',
        value: '30',
        goods_id: "3a4c0427-c8d6-48ad-9c8e-386f5737efcf"
    }, {
        name: '老君仙丹',
        coin: '金币：',
        valuename: '能量：',
        img: food4,
        scribe: ['一颗大补', '性价比最高'],
        price: '35',
        value: '50',
        goods_id: "b4da0908-4aea-40b4-b20d-e88ddc42e22d"
    }]);
    const handleBack = () => {
        navigate(`/pet`);
    };

    // const gotoRecord = () => {
    //     navigate(`/coinRecord`);
    // }
    const exChange = (item) => {
        StoreExchange({ goods_id: item.goods_id, num: 1 }).then(res => {
            if (res?.code == 0) {
                message.info('兑换成功！');
                getUserInfo({}).then((infoRes) => {
                    if (infoRes?.data?.coin_remain !== undefined) {
                        setCoin(infoRes.data.coin_remain);
                    }
                    if (infoRes?.data) dispatch(setUser(infoRes.data));
                });
            } else {
                message.info('金币不足');
            }
        });
    }
    useEffect(() => {
        getStoreGoodList({ page: 1, size: 10 }).then(res => {
            // console.log(res, 'res')
        });
        getUserInfo({}).then(res => {
            if (res?.data?.coin_remain !== undefined) setCoin(res.data.coin_remain);
            if (res?.data) dispatch(setUser(res.data));
        });
    }, [dispatch]);

    return (
        <div className='foodList-container'>
            <img src={back} className='foodList-back' onClick={handleBack} />
            <div className='foodList-title'>
                <img src={coinMarket} />
                {/* <div className='fonts'>-金币商城-</div> */}
            </div>
            <div className='foodList-content'>

                <div className='foodList-coin'>
                    <div className='item'>
                        {/* <img src={gold} /> */}
                        <span>我的金币：</span>
                        <span className="coin">{coin}</span>
                    </div>
                    {/* <div className='item' onClick={gotoRecord}>
                        <img src={gift} />
                        兑换记录
                    </div> */}
                </div>

                <div className='foodList-list'>
                    {foodList.map((item, index) => {
                        return <div className='item' key={index}>
                            <div className='image'><img src={item.img} /></div>
                            <div className='scribe'>{item.scribe.map((i, j) => {
                                return <span key={j} className='lab'>{i}</span>
                            })}</div>
                            <div className='content'>
                                <div className='name'>{item.name}</div>
                                <div className='coin'>
                                    {/*  <img src={gold} /> */}
                                    {item.coin}
                                    <span className='price'>{item.price}</span>
                                </div>
                                <div className='value'>
                                    {item.valuename}
                                    <span className='price'>{item.value}</span>
                                </div>
                                <div className='btn' onClick={() => exChange(item)}>兑换</div>
                            </div>

                        </div>
                    })}

                </div>
            </div>
        </div>
    );
};

export default FoodList; 